import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, Row, Col, Badge, ListGroup, Container,Modal  } from 'react-bootstrap';
import { profileDetails, requestUpdateProfile } from '../../redux/actions/SupplierActions';
import { toast } from 'react-toastify';
import swal from 'sweetalert2';
import { getDisplayDateTimeFormat } from '../../util/generalUtills';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import Preloader from '../../Components/Preloader';
import UpdateProfile from '../../Components/FormComponent/UpdateProfile';
import profilePic from "../../assets/images/users/user-1.jpg";

const ProfileIndex = () => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [supplierID, setSupplierID] = useState(null);
  const [keyPoints, setKeyPoints] = useState([]);
  const {
    AuthReducer: { auth, errors, loading },
    supplierReducer: { supplierDetails, errorsSupplier, loadingSupplier,message },
  } = useSelector((state) => state);
  useEffect(() => {
    dispatch(profileDetails(auth?.token));
  }, [dispatch]);

  useEffect(() => {
    const initialKeyPoints = JSON.parse(supplierDetails?.key_points || "[]"); 
    setKeyPoints(Array.isArray(initialKeyPoints) ? initialKeyPoints : []);
  }, [supplierDetails]);
  
  const hideModel = () => {
      setShowModal(false);
      setSupplierID(null);
  };

  const [showRequest, setShowRequest] = useState(false);

  useEffect(() => {
    if (message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch({ type: 'RESET_SUPPLIER_STATUS' });
      dispatch(profileDetails(auth?.token));
    }
  }, [message, dispatch]);

  const profileFields = [
    supplierDetails?.business_name,
    supplierDetails?.designation,
    supplierDetails?.total_experience,
    supplierDetails?.sectors?.length ? supplierDetails?.sectors : null,
    supplierDetails?.industries?.length ? supplierDetails?.industries : null,
    supplierDetails?.type,
    supplierDetails?.address,
    supplierDetails?.state,
    supplierDetails?.city,
    supplierDetails?.pincode,
    supplierDetails?.website_url,
    supplierDetails?.key_points?.length ? supplierDetails?.key_points : null,
    supplierDetails?.additional_info,
    supplierDetails?.bank_name,
    supplierDetails?.bank_ifsc_code,
    supplierDetails?.bank_branch_name,
    supplierDetails?.bank_account_number,
    supplierDetails?.bank_person_name,
    supplierDetails?.created_at,
  ];
  const totalFields = profileFields.length;
  const filledFields = profileFields.filter(
    (field) =>
      field !== null &&
      field !== undefined &&
      (typeof field === 'string' ? field.trim() !== '' : true)
  ).length;

  const percentage = Math.round((filledFields / totalFields) * 100);
  return (
    <>
      <Container>
        <Row className="mt-5">
          <Col md={4}>
            <Card className="shadow-lg rounded text-center">
              <Card.Body>
                <img
                  src={
                    supplierDetails?.profile_image
                      ? `https://iid-bucket-s3-new.s3.ap-south-1.amazonaws.com/${supplierDetails.profile_image}`
                      : profilePic
                  }
                  alt="Supplier"
                  className="img-fluid rounded-circle mb-3"
                  style={{
                    width: '200px',
                    height: '200px',
                    objectFit: 'cover',
                    border: '4px solid #ddd',
                  }}
                />
                <h4 className="font-weight-bold mb-2">{supplierDetails?.name}</h4>
                <div class="progress" style={{height:"20px"}}>
                    <div 
                    class="progress-bar" 
                    role="progressbar" 
                    style={{width:`${percentage}%`,backgroundColor: (percentage >= 100) ? '#4caf50':''}} 
                    aria-valuenow={percentage} 
                    aria-valuemin="0" 
                    aria-valuemax="100">Profile Completed {percentage}%</div>
                </div>
                <div className="mt-3">
                  <Badge bg={supplierDetails?.approved == 1 ? "success" : "danger"}>{supplierDetails?.approved == 1 ? 'Approved':'Unapproved'}</Badge>
                </div>
                <div className="mt-4">
                  <Button
                    variant="success"
                    className="me-2 shadow-lg"
                    onClick={() => { 
                      if(supplierDetails?.approved == 1 && supplierDetails?.profile_update_request !== 'Approved'){
                        setShowRequest(true);
                      }else if(supplierDetails?.profile_update_request === 'Approved' ){
                        setShowModal(true); 
                      }
                      setSupplierID(supplierDetails.id); 
                    }}
                    style={{
                      borderRadius: '50px',
                      padding: '10px 20px',
                      fontWeight: 'bold',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#28a745')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#198754')}
                  >
                    <FontAwesomeIcon icon={faEdit} /> Edit
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={8}>
            <Card className="shadow-lg rounded">
              <Card.Body>
                <h5 className="mb-4" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Supplier Details</h5>
                <ListGroup variant="flush">
                  {[
                    { label: 'Business name', value: supplierDetails?.business_name },
                    { label: 'Designation', value: supplierDetails?.designation },
                    { label: 'Total Experience', value: supplierDetails?.total_experience ? `${supplierDetails?.total_experience} year`:'' },
                    {
                      label: 'Sector', value: supplierDetails?.sectors?.map((sec) => sec?.sector?.name).join(', ')
                    },
                    {
                      label: 'Industries', value: supplierDetails?.industries?.map((ind) => ind?.industry?.name).join(' , ')
                    },
                    { label: 'Type', value: supplierDetails?.type },
                    { label: 'Address', value: supplierDetails?.address },
                    { label: 'State', value: supplierDetails?.state },
                    { label: 'City', value: supplierDetails?.city },
                    { label: 'Pincode', value: supplierDetails?.pincode },
                    { label: 'Website URL', value: supplierDetails?.website_url },
                    {
                      label: 'Key Points', value: keyPoints?.map((ind) => ind).join(`<br/>`)
                    },
                    { label: 'Additional Information', value: supplierDetails?.additional_info },
                    { label: 'Bank Name', value: supplierDetails?.bank_name },
                    { label: 'Bank Ifsc Code', value: supplierDetails?.bank_ifsc_code },
                    { label: 'Bank Branch Name', value: supplierDetails?.bank_branch_name },
                    { label: 'Bank Account Number', value: supplierDetails?.bank_account_number },
                    { label: 'Bank Person Name', value: supplierDetails?.bank_person_name },
                    { label: 'Registered At', value: getDisplayDateTimeFormat(supplierDetails?.created_at) },
                  ].map((item, index) => (
                    <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                      <strong>{item.label}:</strong>
                      <span dangerouslySetInnerHTML={{ __html: item.value }}></span>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <UpdateProfile show={showModal} onHide={() => hideModel()} editId={supplierID}/>
      <Modal show={showRequest} onHide={()=>setShowRequest(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Profile Edit Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {supplierDetails?.profile_update_request === 'Requested' ? (
          <>
          <p>Your request for profile update approval has been submitted. Waiting for Approvel!</p>
          </>
        ) : supplierDetails?.profile_update_request === 'Rejected' ? (
          <p>Your request for profile update approval has been rejected.</p>
        ) : (
          <>
            <p>Your profile has been approved. To make any further changes, you must first request edit approval from our team.</p>
            <p>Please submit a request for profile edit approval.</p>
          </>
        )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>setShowRequest(false)}>
            Close
          </Button>
          {!supplierDetails?.profile_update_request ? (
          <Button variant="primary" onClick={() => {
            dispatch(requestUpdateProfile(auth?.token));
            setShowRequest(false);
            }}>
            Submit Profile Edit Request
          </Button>
          ):supplierDetails?.profile_update_request === 'Rejected' ? (
          <Button variant="primary" onClick={() => {
            setShowRequest(false);
            dispatch(requestUpdateProfile(auth?.token));
            }}>
            Submit Profile Edit Request
          </Button>
          ):null}
        </Modal.Footer>
      </Modal>
      {loadingSupplier && (<Preloader />)}
    </>
  );
};

export default ProfileIndex;
